<div class="excel-import-container" 
     style="padding: 20px; background: #f0f8ff; border-radius: 12px; 
            border: 1px solid #d0e8ff; margin-bottom: 25px;">

  <h4 style="margin-bottom: 20px; color: #333; display: flex; align-items: center; gap: 10px;">
    <i class="dx-icon-upload" style="font-size: 20px; color: #5cb85c;"></i>
    استيراد حضور وانصراف من Excel (للفروع بدون بصمة)
  </h4>

  <!-- Buttons -->
  <div style="display: flex; align-items: center; gap: 15px; flex-wrap: wrap; margin-bottom: 20px;">
    
    <input type="file" (change)="onFileUploaded($event)" 
           accept=".xlsx, .xls" #excelInput style="display:none" />

    <dx-button text="اختر ملف Excel" icon="xlsxfile" type="success"
               [stylingMode]="'contained'" [disabled]="isUploadingBulk"
               (onClick)="excelInput.click()">
    </dx-button>

    <dx-button text="تحميل القالب" icon="download" type="normal"
               [stylingMode]="'outlined'" (onClick)="downloadTemplate()">
    </dx-button>

    <div *ngIf="isUploadingBulk"
         style="display: flex; align-items: center; gap: 8px; 
                padding: 8px 15px; background: #d4edda; border-radius: 6px;">
      <dx-load-indicator [visible]="true" [height]="20" [width]="20"></dx-load-indicator>
      <span style="font-size: 14px; color: #155724; font-weight: 500;">جاري المعالجة...</span>
    </div>
  </div>

  <!-- Results -->
  <div *ngIf="bulkResults" style="margin-top: 25px;">
    <dx-tab-panel [selectedIndex]="bulkResults.failedCount > 0 ? 1 : 0"
                  [animationEnabled]="true" [rtlEnabled]="true">

      <!-- ✅ Success Tab -->
      <dxi-item title="الناجحة ({{bulkResults.successCount}})" icon="check">
        <div style="padding: 15px;">

          <div *ngIf="bulkResults.successCount === 0"
               style="text-align: center; padding: 40px; color: #999;">
            <i class="dx-icon-info" style="font-size: 48px;"></i>
            <p>لا توجد سجلات ناجحة</p>
          </div>

          <dx-data-grid *ngIf="bulkResults.successCount > 0"
                        [dataSource]="bulkResults.successItems"
                        [showBorders]="true" [height]="350"
                        [columnAutoWidth]="true" [showRowLines]="true"
                        [rowAlternationEnabled]="true" [rtlEnabled]="true">

            <dxi-column dataField="employeeName" caption="اسم الموظف"></dxi-column>
            <dxi-column dataField="dateOfDay" caption="التاريخ" 
                        dataType="date" format="dd/MM/yyyy"></dxi-column>
            <dxi-column dataField="timeAttending" caption="وقت الحضور"></dxi-column>
            <dxi-column dataField="timeLeave" caption="وقت الانصراف"></dxi-column>
            <dxi-column dataField="attendanceEarly" caption="حضور مبكر"></dxi-column>
            <dxi-column dataField="attendanceLate" caption="تأخير"></dxi-column>
            <dxi-column dataField="leaveEarly" caption="انصراف مبكر"></dxi-column>
            <dxi-column dataField="leaveAfterTime" caption="انصراف متأخر"></dxi-column>
            <dxi-column dataField="workDurationSystemName" caption="نظام العمل"></dxi-column>
            <dxi-column dataField="employeeDurationStartTime" caption="بداية الفتره"></dxi-column>
            <dxi-column dataField="employeeDurationEndTime" caption="نهاية الفتره"></dxi-column>

          </dx-data-grid>
        </div>
      </dxi-item>

      <!-- ❌ Failed Tab -->
      <dxi-item title="الأخطاء ({{bulkResults.failedCount}})" icon="close">
        <div style="padding: 15px;">

          <div *ngIf="bulkResults.failedCount === 0"
               style="text-align: center; padding: 40px; color: #28a745;">
            <i class="dx-icon-check" style="font-size: 48px;"></i>
            <p style="font-size: 16px; font-weight: 500;">رائع! جميع السجلات تم إضافتها بنجاح</p>
          </div>

          <div *ngIf="bulkResults.failedCount > 0">
            <dx-button text="تصدير الأخطاء لإعادة التعديل" icon="exportxlsx"
                       type="danger" [stylingMode]="'outlined'"
                       (onClick)="exportFailedRows()" style="margin-bottom: 15px;">
            </dx-button>

            <dx-data-grid [dataSource]="bulkResults.errors"
                          [showBorders]="true" [height]="350"
                          [columnAutoWidth]="true" [showRowLines]="true"
                          [rowAlternationEnabled]="true" [rtlEnabled]="true">

              <dxi-column dataField="rowIndex" caption="السطر" 
                          [width]="70" alignment="center"
                          cellTemplate="rowIndexTemplate"></dxi-column>

              <div *dxTemplate="let data of 'rowIndexTemplate'">
                <span style="background: #dc3545; color: white; 
                             padding: 3px 8px; border-radius: 4px; font-weight: 600;">
                  {{data.value}}
                </span>
              </div>

              <dxi-column dataField="employeeName" caption="اسم الموظف"></dxi-column>
              <dxi-column dataField="dateOfDay" caption="التاريخ" 
                          dataType="date" format="dd/MM/yyyy"></dxi-column>
              <dxi-column dataField="errors" caption="الأخطاء" cellTemplate="errorTemplate"></dxi-column>

              <div *dxTemplate="let data of 'errorTemplate'">
                <div *ngFor="let err of data.value" 
                     style="color:#dc3545; font-weight:500; font-size:13px; margin-bottom:5px;">
                  <i class="dx-icon-close" style="font-size:12px; margin-left:4px;"></i>
                  {{err}}
                </div>
              </div>

            </dx-data-grid>
          </div>
        </div>
      </dxi-item>

    </dx-tab-panel>
  </div>
</div>